module.exports = {
  strings: {
    pluginNameInstagram: 'Instagram'
  }
};